export default __webpack_public_path__ + "static/media/019-god of wealth.ea9ae264.svg";